export const filterPrimaryCTA = (ctasData = []) => {
    return ctasData.filter(x => x.btnAttributes && Object.keys(x.btnAttributes).length > 0).slice(0, 1);
};